import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: 'AIzaSyAM3-1EPuJcqK71B0Sz9hvIw-BUOssWyP4',
  authDomain: 'visionarygames-c1a39.firebaseapp.com',
  projectId: 'visionarygames-c1a39',
  storageBucket: 'visionarygames-c1a39.firebasestorage.app',
  messagingSenderId: '524880379506',
  appId: '1:524880379506:web:a64562a8340e441aec8ceb',
  measurementId: 'G-9S1NLFZXSZ',
};

const app = initializeApp(firebaseConfig);

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6LeEIowsAAAAALE_VzwELrhSc9oyFnwtXfJw8nzw'),
  isTokenAutoRefreshEnabled: true,
});

const db = getFirestore(app);

let analyticsInstance;

export function initAnalytics() {
  if (typeof window === 'undefined') return;
  isSupported()
    .then((supported) => {
      if (supported && !analyticsInstance) {
        analyticsInstance = getAnalytics(app);
        logEvent(analyticsInstance, 'page_view', {
          page_location: window.location.href,
          page_path: window.location.pathname || '/',
        });
      }
    })
    .catch(() => {});
}

// Auto-init only if user has already given consent
if (typeof window !== 'undefined' && localStorage.getItem('cookie_consent') === 'accepted') {
  initAnalytics();
}

const getAnalyticsInstance = () => analyticsInstance;

export { db, getAnalyticsInstance };
